import React from "react";

import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { X } from "lucide-react";

import { useCreateRound } from "../hooks";
import { RoundForm } from "../components";

import { Header } from "../../../components/header";
import { parseSearchParams } from "../../../helpers/clean-object";

export const CreateRound: React.FC = () => {
  const [params] = useSearchParams();
  const { form, submit, loading } = useCreateRound({
    defaultValues: {
      ...parseSearchParams(params),
    },
    onCompleted: () => {
      toast.success("La tournée a été enregistrée avec succès");
    },
  });

  return (
    <>
      <Header
        title="Tournée"
        subtitle="Nouvelle Tournée"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/rounds`,
            icon: <X />,
          },
        ]}
      />
      <div className="main-container">
        <RoundForm
          loading={loading}
          submit={submit}
          form={form}
          disabledFields={Object.keys(parseSearchParams(params))}
        />
      </div>
    </>
  );
};
